module.exports = __webpack_public_path__ + "static/media/spinner.28ebd5ba.svg";